import React from 'react';
import { ComponentErrorBoundary } from '@app/utilities';
import { useCreateChargeOffReason, useRefreshChargeOffReasons, useUpdateChargeOffReason } from '@app/sdk';
import { FormProvider, useForm } from 'react-hook-form';
import { FormContainer, Input, InputProps } from '@app/shared';
import { ChargeOffReasonModel } from '@app/models';

export function ChargeOffReasonForm({ chargeOffReason }: { chargeOffReason: ChargeOffReasonModel }) {
  const { mutateAsync: update, isPending: isUpdating } = useUpdateChargeOffReason();
  const { mutateAsync: create, isPending: isCreating } = useCreateChargeOffReason();
  const refreshChargeOffReasons = useRefreshChargeOffReasons();
  const isSubmitting = () => isUpdating || isCreating;

  async function onSaveReason(data: ChargeOffReasonModel) {
    if (chargeOffReason?.id) {
      await update({ id: chargeOffReason.id, request: { id: chargeOffReason.id, ...data } });
    } else {
      await create(data);
    }
    refreshChargeOffReasons();
  }

  const formContext = useForm<ChargeOffReasonModel>();

  const reason: InputProps<ChargeOffReasonModel> = {
    name: 'reason',
    label: 'Reason',
    defaultValue: chargeOffReason?.reason,
  };

  return (
    <ComponentErrorBoundary>
      <FormProvider {...formContext}>
        <FormContainer isSubmitting={isSubmitting()} onSubmit={onSaveReason} disableButtons>
          <Input {...reason} disabled />
        </FormContainer>
      </FormProvider>
    </ComponentErrorBoundary>
  );
}
